import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const REF_STORAGE_KEY = "cosmic_ref_code";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    let refCode = null;
    try { refCode = sessionStorage.getItem(REF_STORAGE_KEY); } catch { /* noop */ }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId, ref_code: refCode });
        try { sessionStorage.removeItem(REF_STORAGE_KEY); } catch { /* noop */ }
        await refresh();
        navigate("/levels", { replace: true });
      } catch {
        navigate("/login?google_error=1", { replace: true });
      }
    })();
  }, [hash, navigate, refresh]);

  return <div className="min-h-screen bg-[#05050a]" data-testid="google-auth-callback" />;
}

export function GoogleAuthGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return children;
}
